import { render, staticRenderFns } from "./shopkefu.vue?vue&type=template&id=35b2b5ec&scoped=true&"
import script from "./shopkefu.vue?vue&type=script&lang=js&"
export * from "./shopkefu.vue?vue&type=script&lang=js&"
import style0 from "./shopkefu.vue?vue&type=style&index=0&id=35b2b5ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b2b5ec",
  null
  
)

export default component.exports